import { createWhatsAppLink } from "../utils/helper.ts";

export const siteData = {
  company: {
    name: "Gemburin Sejahtera",
    tagline: "Jasa Kontraktor Penghijauan",
    description: "Solusi penghijauan lahan Perkotaan, Pertambangan, Perumahan, Kawasan Industri, Jalan Tol, Perusahaan, Instansi, Taman, dan sebagainya.",
    address: "Branggahan, Ngadiluwih, Kediri, Jawa Timur",
    phone: "089657735647",
    email: "gemburin@gmail.com",
    whatsapp: createWhatsAppLink(
      `Halo Gemburin Sejahtera👋🏻, 
Saya ingin konsultasi mengenai jasa penghijauan.
`
    ),
    instagram: "https://instagram.com/muh_richo",
    facebook: "https://instagram.com/muh_richo",
    shopee: "https://shopee.co.id/gemilangkembang",
    stats: [
      { value: "1000+", label: "Klien Puas" },
      { value: "5+", label: "Proyek / Bulan" },
      { value: "10+", label: "Tahun Pengalaman" },
      { value: "34+", label: "Provinsi Terjangkau" },
    ]
  },
  nav: [
    { label: "Home", href: "#home" },
    { label: "Tentang Kami", href: "#tentang" },
    { label: "Layanan", href: "#layanan" },
    { label: "Portofolio", href: "#portofolio" },
    { label: "Edukasi", href: "#edukasi" },
    { label: "Hubungi Kami", href: "#kontak" },
  ],
  services: [
    {
      id: 1,
      icon: "🌿",
      title: "Jasa Landscape Taman",
      description: "Keindahan taman mampu memberikan energi positif. Pastikan rumah, kantor, atau kawasan Anda dihiasi oleh taman indah karya kami.",
      features: ["Desain taman custom", "Taman rumah & kantor", "Taman kawasan industri", "Perawatan berkala"]
    },
    {
      id: 2,
      icon: "🌳",
      title: "Jasa Penghijauan & Reboisasi",
      description: "Sudah dipercaya oleh banyak perusahaan dan instansi pemerintah untuk penghijauan taman, wisata, perkotaan, tambang, dan tol.",
      features: ["Reboisasi lahan tambang", "Penghijauan jalan tol", "Taman kota & wisata", "Kawasan industri"]
    },
    {
      id: 3,
      icon: "🌱",
      title: "Suplai Bibit & Pohon",
      description: "Menyediakan berbagai macam bibit buah, pohon, dan bunga berkualitas untuk kebutuhan budidaya atau penghijauan lahan Anda.",
      features: ["Bibit buah unggul", "Pohon peneduh", "Tanaman hias & bunga", "Pengiriman se-Indonesia"]
    },
  ],
  benefits: [
    { icon: "🌾", title: "Langsung dari Pembudidaya", desc: "Tanaman kami diambil langsung dari pembudidaya, menjamin kualitas terbaik." },
    { icon: "🌲", title: "Koleksi Lengkap", desc: "Menyediakan berbagai jenis tanaman bibit hingga pohon besar untuk proyek penghijauan." },
    { icon: "🛡️", title: "Garansi 3 Bulan", desc: "Untuk proyek berskala besar, kami memberikan retensi hingga 3 bulan." },
    { icon: "🚚", title: "Pengiriman Cepat & Aman", desc: "Kami menjamin pohon sampai dengan aman dan tepat waktu ke seluruh Indonesia." },
    { icon: "⭐", title: "Terpercaya", desc: "Dipercaya menangani proyek penghijauan berbagai perusahaan dan instansi." },
    { icon: "💰", title: "Harga Terjangkau", desc: "Langsung dari petani, kami berikan harga terjangkau tanpa mengorbankan kualitas." },
    { icon: "🗺️", title: "Kirim Se-Indonesia", desc: "Melayani proyek dan pengiriman di seluruh wilayah Indonesia." },
    { icon: "💬", title: "Free Konsultasi", desc: "Layanan konsultasi gratis selamanya untuk semua pelanggan kami." },
  ],
  projects: [
    { name: "PT. MHI", desc: "Pengerjaan kolam dan taman kantor PT. MHI", category: "Taman Kantor" },
    { name: "PT. IMIP Morowali", desc: "Penghijauan di PT. Indonesia Morowali Industrial Park", category: "Kawasan Industri" },
    { name: "PT. Adhi Karya", desc: "Penghijauan Bendungan bersama PT. Adhi Karya dan PT. Nindya Karya", category: "Infrastruktur" },
    { name: "Pemerintah Daerah", desc: "Proyek penghijauan taman kota dan ruang terbuka hijau", category: "Taman Kota" },
  ],
  testimonials: [
    {
      name: "Budi Santoso",
      role: "Manager PT. MHI",
      text: "Agrotani Sejahtera memberikan hasil yang luar biasa. Taman kantor kami kini menjadi kebanggaan seluruh karyawan. Profesional dan tepat waktu.",
    },
    {
      name: "Ir. Hendra Wijaya",
      role: "Project Manager PT. IMIP",
      text: "Kami sangat puas dengan layanan penghijauan yang diberikan. Kualitas tanaman sangat baik dan tim sangat responsif dalam menangani setiap kebutuhan.",
    },
    {
      name: "Dra. Sari Dewi",
      role: "Kepala Dinas Lingkungan Hidup",
      text: "Mitra terpercaya untuk proyek penghijauan kota. Agrotani Sejahtera selalu memberikan tanaman berkualitas dan pengerjaan yang rapi dan bersih.",
    },
  ],
  blogPosts: [
    {
      title: "Tips Merawat Taman agar Tetap Hijau Sepanjang Tahun",
      category: "Tips & Trik",
      date: "15 Nov 2024",
      excerpt: "Pelajari cara merawat taman Anda agar selalu terlihat segar dan hijau meski di musim kemarau.",
    },
    {
      title: "Manfaat Penghijauan untuk Kawasan Industri",
      category: "Edukasi",
      date: "02 Nov 2024",
      excerpt: "Penghijauan bukan hanya soal keindahan, tapi juga menyerap polusi dan meningkatkan produktivitas karyawan.",
    },
    {
      title: "Jenis Tanaman Terbaik untuk Taman Tropis Indonesia",
      category: "Panduan",
      date: "20 Okt 2024",
      excerpt: "Rekomendasi tanaman lokal yang cocok untuk iklim tropis dan mudah dirawat.",
    },
  ]
};
